import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Saves entity ledger details after file upload.
 * POST api/Onboarding/save-entity-ledger
 *
 * @param {{
 *   entityLedgerList: Array<{
 *     entityPrimaryId: number,
 *     entityId: string,
 *     isLedger: string,
 *     ledgerName: string,
 *     fileName: string,
 *     filePath: string
 *   }>,
 *   isLedgerSendByEmail: boolean,
 *   createdBy: string,
 *   email: string
 * }} params
 * @returns {{ success: boolean, message?: string, error?: string }}
 */
export const saveEntityLedgerAction = async ({
  entityLedgerList,
  isLedgerSendByEmail,
  createdBy,
  email,
}) => {
  try {
    const payload = {
      entityLedgerList,
      isLedgerSendByEmail,
      createdBy,
      email,
    };

    const response = await apiClient.post(
      ATP_API_URL.SAVE_ENTITY_LEDGER,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      },
    );

    if (response?.status === 200) {
      return {
        success: true,
        message: response.data?.message || "Ledger saved successfully",
        data: response.data,
      };
    }
    return { success: false, error: "Failed to save ledger" };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to save ledger",
    };
  }
};
